export default __webpack_public_path__ + "static/media/ISA_cloudxier2.21163ddc.png";